import React from 'react';
import Card from '../components/Card';
import './Contact.css';

const Contact = () => {
  return (
    <div className="contact-page">
      <h1>Contact Us</h1>

      <section className='card-section'>
      <Card 
        heading="Get In Touch"
        body="Feel free to reach out to us at info@quipo.in for any queries."
      />
      </section>
      <section className='card-section'>
      <Card 
        heading="Reg. Office"
        body="8-1-40/A/110/A, Samatha Colony,Shaikpet, Hyderabad , India -  500008 ."
      />
      </section>
    </div>
  );
};

export default Contact;
